
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remove-fake-account",
      function () {
        return require("private-next-pages/remove-fake-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remove-fake-account"])
      });
    }
  